import { render, staticRenderFns } from "./GreetAddition.vue?vue&type=template&id=80c55a9c&scoped=true"
import script from "./GreetAddition.vue?vue&type=script&lang=js"
export * from "./GreetAddition.vue?vue&type=script&lang=js"
import style0 from "./GreetAddition.vue?vue&type=style&index=0&id=80c55a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c55a9c",
  null
  
)

export default component.exports